import axios from "./configApi";

export const getStaticCountries = async () => {
  try {
    const res = await axios.get(`/cities/static-countries`, {});
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getStaticStates = async (countryCode: string) => {
  try {
    const res = await axios.get(`/cities/static-states/${countryCode}`);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getStaticCitiesOfState = async (
  countryCode: string,
  stateCode: string
) => {
  try {
    const res = await axios.get(
      `/cities/static-cities/${countryCode}/${stateCode}`
    );
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
